import { render, staticRenderFns } from "./brandSpecial.vue?vue&type=template&id=cb2379a4&scoped=true&"
import script from "./brandSpecial.vue?vue&type=script&lang=js&"
export * from "./brandSpecial.vue?vue&type=script&lang=js&"
import style0 from "./brandSpecial.vue?vue&type=style&index=0&id=cb2379a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2379a4",
  null
  
)

export default component.exports